import * as React from 'react';
import TextInput from './TextInput';
import { Rule, RulesMessages } from '../utils/validator';
import { HatType } from './Hat';

interface EmailInputProps {
  placeHolder?: string;
  name: string;
  value?: string;
  id: string;
  label?: string;
  required?: boolean;
  hasError: boolean;
  maxLength?: number;
  theme?: 'night' | 'day';
  errors?: any;
  validationRules?: Rule[];
  rulesMessages?: RulesMessages;
  onChange?: Function;
  onComplete?: Function;
  onError?: Function;
  onEsc?: Function;
  onEnter?: Function;
  onLeft?: Function;
  onRight?: Function;
  onUp?: Function;
  onDown?: Function;
  onSpace?: Function;
  hat?: HatType[];
  readOnly?: boolean;
  disabled?: boolean;
  toolTip?: React.ReactNode;
  autocomplete?: string;
}

export default function EmailInput(props: EmailInputProps) {
  const componentPropsRules: Rule[] = [];
  if (props.validationRules) {
    componentPropsRules.push(...props.validationRules);
  }

  if (!componentPropsRules.some(rule => rule.ruleName === 'email')) {
    componentPropsRules.push({
      ruleName: 'email',
      message: props.rulesMessages && props.rulesMessages.email,
      defaultMessage: `${props.label} is not valid.`
    });
  }

  return (
    <TextInput
      placeHolder={props.placeHolder}
      name={props.name}
      value={props.value}
      id={props.id}
      label={props.label || 'Email'}
      required={props.required}
      hasError={props.hasError}
      maxLength={props.maxLength || 320}
      theme={props.theme}
      errors={props.errors}
      validationRules={componentPropsRules}
      autocomplete={props.autocomplete}
      onChange={props.onChange}
      onComplete={props.onComplete}
      onError={props.onError}
      onEsc={(inputValue: string) => {
        if (props.onEsc !== undefined) {
          props.onEsc(inputValue);
        }
      }}
      onEnter={(inputValue: string) => {
        if (props.onEnter !== undefined) {
          props.onEnter(inputValue);
        }
      }}
      onUp={(inputValue: string) => {
        if (props.onUp !== undefined) {
          props.onUp(inputValue);
        }
      }}
      onDown={(inputValue: string) => {
        if (props.onDown !== undefined) {
          props.onDown(inputValue);
        }
      }}
      onLeft={(inputValue: string) => {
        if (props.onLeft !== undefined) {
          props.onLeft(inputValue);
        }
      }}
      onRight={(inputValue: string) => {
        if (props.onRight !== undefined) {
          props.onRight(inputValue);
        }
      }}
      onSpace={(inputValue: string) => {
        if (props.onSpace !== undefined) {
          props.onSpace(inputValue);
        }
      }}
      allowRegex={/^\S*$/}
      hat={props.hat}
      readOnly={props.readOnly}
      disabled={props.disabled}
      toolTip={props.toolTip}
    />
  );
}
